import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

import { ISettings } from "../models/Settings";

export const defaultSettings: ISettings = {
  versionCode: 1,
  versionName: APP_VERSION,
  enableLog: false,
  provider: {
    id: "uderly",
    title: "Uderly",
    company: { name: "Uderly Ltd", address: "Gregs Buildings, 1 Booth Street, M2 4AD, Manchester, United Kingdom" },
    web: {
      title: "Uderly",
      domain: "uderly.com",
      site: "uderly.com"
    },
    socials: [
      {
        title: "Facebook",
        url: "https://www.facebook.com/uderly",
        icon: <FontAwesomeIcon icon={faFacebookF} />
      },
      {
        title: "LinkedIn",
        url: "https://www.linkedin.com/company/uderly",
        icon: <FontAwesomeIcon icon={faLinkedinIn} />
      }
    ]
  },
  project: {
    id: "uderly",
    title: "Uderly",
    web: {
      title: "Uderly",
      domain: "uderly.com",
      site: "uderly.com"
    },
    logo: {
      original: "/assets/images/logo.png",
      originalDark: "/assets/images/logo-dark.png",
      mini: "/assets/images/logo-mini.png",
      miniDark: "/assets/images/logo-mini-dark.png"
    }
  },
  auth: null,
  stripe: null,
  storeId: 1,
  appId: null,
  apiUrl: "https://api.net.uderly.com",
  localhostUrl: "http://localhost:4200",
  isLocalhost: () => window.location.hostname === "localhost",
  cookies: false,
  siteMap: undefined,
  googleAnalytics: {
    trackingId: undefined // TODO: Set Uderly GA
  }
};

const Settings = Object.assign({}, defaultSettings);

export default Settings;